import { getApiClient } from "@punchup/utils";
import { SpecialRow } from "../../legacy/specials";
import { VideoUploadRow } from "../../models/video";
import type { ManagerSpecialRow } from "../../models/specials";
import type {
  InitiateVideoUploadRequest,
  InitiateVideoUploadResponse,
} from "../../models/videos";

export async function getComedianManagerSpecials({
  comedianId,
  collectionId,
}: {
  comedianId: string;
  collectionId?: string;
}) {
  return getApiClient()
    .get<{
      data: { approved: ManagerSpecialRow[]; pending: VideoUploadRow[] };
    }>(
      `/api/v2/manager/videos?comedian_id=${comedianId}${collectionId ? `&collection_id=${collectionId}` : ""}`
    )
    .then((data) => data.data);
}

export async function publishSpecial(specialId: string): Promise<SpecialRow> {
  return getApiClient()
    .post<{ data: SpecialRow }>(`/api/v2/manager/videos/${specialId}/publish`)
    .then((data) => data.data);
}

export async function unpublishSpecial(specialId: string): Promise<SpecialRow> {
  return getApiClient()
    .del<{ data: SpecialRow }>(`/api/v2/manager/videos/${specialId}/publish`)
    .then((data) => data.data);
}

export async function updateComedianFeaturedSpecial(specialId: string) {
  return getApiClient()
    .post<{ data: { success: boolean } }>(
      `/api/v2/manager/videos/${specialId}/feature`
    )
    .then((data) => data.data);
}

export async function initiateVideoUpload(
  params: InitiateVideoUploadRequest
): Promise<InitiateVideoUploadResponse> {
  return getApiClient()
    .post<{ data: InitiateVideoUploadResponse }>(
      "/api/v2/manager/videos/upload/initiate",
      params
    )
    .then((data) => data.data);
}
